import { onboardingGetters } from '@/store/modules/onboarding/routines'

export default {
  [onboardingGetters.STAGE_GOAL]: state => state.stageGoal
}
